import Reflux from "reflux";
import { singletonStore } from "logic/singleton";
import { MetricsActions, MetricsStore } from "stores/metrics/MetricsStore";
export const GlobalThroughputStore = singletonStore(
  "core.GlobalThroughput",
  () => Reflux.createStore({
    listenables: [],
    throughput: {
      input: 0,
      output: 0,
      loading: false
    },
    metrics: {
      input: "org.graylog2.throughput.input.1-sec-rate",
      output: "org.graylog2.throughput.output.1-sec-rate",
      loading: true
    },
    init() {
      MetricsActions.addGlobal(this.metrics.input);
      MetricsActions.addGlobal(this.metrics.output);
      this.listenTo(MetricsStore, this.updateMetrics);
      setInterval(MetricsActions.list, this.INTERVAL);
    },
    getInitialState() {
      return { throughput: this.throughput };
    },
    INTERVAL: 2e3,
    updateMetrics(update) {
      if (!update.metrics) {
        return;
      }
      const input = Object.keys(update.metrics).map((nodeId) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = update.metrics[nodeId][this.metrics.input]) == null ? void 0 : _a.metric) == null ? void 0 : _b.value) != null ? _c : 0;
      }).reduce((prev, cur) => prev + cur, 0);
      const output = Object.keys(update.metrics).map((nodeId) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = update.metrics[nodeId][this.metrics.output]) == null ? void 0 : _a.metric) == null ? void 0 : _b.value) != null ? _c : 0;
      }).reduce((prev, cur) => prev + cur, 0);
      this.throughput = { input, output, loading: false };
      this.trigger({ throughput: this.throughput });
    }
  })
);
